import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { BankingBankAccountFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/banking/components/FinishSetupAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/FinishSetupAccountModal/wizardSteps/WizardStepLayout'
import {
  LedgerAccountSelector,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelector'

interface Props {
  bankAccount: BankingBankAccountFragment
  legalEntityId: number
}

export const FinishSetupLedgerAccountWizardStep = ({
  data,
  onDataChanged,
  bankAccount,
  legalEntityId,
}: WizardStepRenderParams<WizardData> & Props) => {
  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_2.title')}
    >
      <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
        <Text.Normal color="grey1000" weight="medium">
          {i18n.t('banking.accounts.accounting.ledger_account')}
        </Text.Normal>
        <Text color="grey800" weight="normal" size="200">
          {i18n.t('banking.accounts.accounting.accounting_account_label')}
        </Text>
        <Box>
          <LedgerAccountSelector
            legalEntityId={legalEntityId}
            currentLedgerAccountName={formatAccountName(bankAccount.accountResource?.account)}
            types={['bank']}
            disabled={false}
            onSelect={(id) => {
              onDataChanged({ ...data, ledgerAccountId: id })
            }}
          />
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
